import Helper from './Helper';

class SVGAnimation {
  constructor(config = {}) {
    this.hoverFocusPairs = [
      {
        data: '.line1',
        numbers: '.Zahlen1'
      },
      {
        data: '.line2',
        numbers: '.Zahlen2'
      },
      {
        data: '.column-one',
        numbers: '.column-one-text'
      },
      {
        data: '.column-two',
        numbers: '.column-two-text'
      },
      {
        data: '.column-three',
        numbers: '.column-three-text'
      },
      {
        data: '.column-four',
        numbers: '.column-four-text'
      }
    ];
    this.freeHTMLElements = document.querySelectorAll('.free-html');

    this.bindEvents();
  }

  bindEvents(){
    this.freeHTMLElements.forEach((freeHTML) => {
      this.hoverFocusPairs.forEach((pair) => {
        let data = freeHTML.querySelector(pair.data);
        let numbers = freeHTML.querySelector(pair.numbers);

        if ( typeof data !== undefined && data !== null ) {
          data.addEventListener('mouseover', e => {
            Helper.addClass(data, 'hover');
            Helper.addClass(numbers, 'hover');
          });

          data.addEventListener('mouseout', e => {
            Helper.removeClass(data, 'hover');
            Helper.removeClass(numbers, 'hover');
          });
        }

        if ( typeof numbers !== undefined && numbers !== null ) {
          numbers.addEventListener('mouseover', e => {
            Helper.addClass(data, 'hover');
            Helper.addClass(numbers, 'hover');
          });

          numbers.addEventListener('mouseout', e => {
            Helper.removeClass(data, 'hover');
            Helper.removeClass(numbers, 'hover');
          });
        }
      });
    });
  }
}

export default SVGAnimation;
